import * as React from 'react';
import { SmsValidationWidget } from '@cian/sms-validation-widget';

export interface IRequestDemandVerifySmsProps {
  demandRequestPhone: string;
  verificationError: string;
  secondsToRetrySms: number;

  retrySendingSms(): void;

  retrySecondsChange(seconds: number): void;

  onApprove(smsCode: string): void;

  onReturnBack(): void;
}

export const RequestDemandVerifySms: React.FC<IRequestDemandVerifySmsProps> = ({
  verificationError,
  secondsToRetrySms,
  retrySendingSms,
  retrySecondsChange,
  onApprove,
  demandRequestPhone,
  onReturnBack,
}) => {
  const [smsCode, setSmsCode] = React.useState('');

  const onRetrySendingSms = React.useCallback(() => {
    setSmsCode('');
    retrySendingSms();
  }, []);

  return (
    <SmsValidationWidget
      phone={demandRequestPhone}
      onApprove={onApprove}
      onSmsCodeChange={setSmsCode}
      retrySecondsChange={retrySecondsChange}
      retrySendingSms={onRetrySendingSms}
      smsCode={smsCode}
      secondsToRetrySms={secondsToRetrySms}
      verificationError={verificationError}
      onReturn={onReturnBack}
    />
  );
};

RequestDemandVerifySms.displayName = 'RequestDemandVerifySms';
